"use client";

import { useAssignSettingReactCompiler } from "@faire/visitor/settings/useSettingReactCompiler";
import { useEffect } from "react";

export const VisitorEffects = () => {
  const assignSettingReactCompiler = useAssignSettingReactCompiler();

  useEffect(() => {
    assignSettingReactCompiler();
  }, [assignSettingReactCompiler]);

  return null;
};
